import React, { useState } from 'react';
import { database } from '.././firebase'; // Import only what's needed

const CreateBNM = () => {
  const [cardNumber, setCardNumber] = useState('');
  const [value, setValue] = useState('');
  const [message, setMessage] = useState('');

  // Function to add a gift card to the database
  const addGiftCard = async (cardNumber, value) => {
    try {
      await database.ref(`giftcards/${cardNumber}`).set({
        value: parseFloat(value),
        used: 0 // Mark as unused
      });
      setMessage('Gift card added successfully.');
    } catch (error) {
      setMessage('Error adding gift card: ' + error.message);
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (cardNumber && value) {
      addGiftCard(cardNumber, value);
    } else {
      setMessage('Please enter both card number and value.');
    }
  };

  return (
    <div>
      <h1>Create Gift Card</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="cardNumber">Card Number:</label>
          <input
            type="text"
            id="cardNumber"
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="value">Value ($):</label>
          <input
            type="number"
            id="value"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
          />
        </div>
        <button type="submit">Add Gift Card</button>
      </form>
      <p>{message}</p>
    </div>
  );
};

export default CreateBNM;
